import MainLayout from '@/common/components/layouts/MainLayout';
import ShowIncidentParticipantsDataCard from '@/common/components/showIncidentParticipantsDataCard/ShowIncidentParticipantsDataCard';
import getVisitShowOtherInformationQueryOption from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitOtherDamagedInformation/getVisitShowOtherDamagedInformationQueryOption';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="زیان‌دیده / کارشناسی" header="titleHeader">
      <OtherShowVisitInformation />
    </MainLayout>
  );
};
const OtherShowVisitInformation = () => {
  const { id, damagedId } = useParams();
  const { data } = useQuery(
    getVisitShowOtherInformationQueryOption({
      damaged_id: damagedId!,
      id: id!,
      source: 'vehicle',
    }),
  );
  return (
    <Box pt={24}>
      <ShowIncidentParticipantsDataCard
        data={data?.visitInformation || []}
        title="اطلاعات بازدید"
      />
    </Box>
  );
};
